import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransferLeadService {


  url = environment.serverAPI9 + "/api/transferLead"; 

  
  constructor(private http: HttpClient) { }

  getAllTrasnfer(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllTransferDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }
  
  getTransferById(leadId: number): Observable<Object> {
    return this.http.get(`${this.url}/${leadId}`);
  }

  leadTransfer(Transfer: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, Transfer);
  }

  leadTransferMultiple(Transfer: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/list`, Transfer);
  }

  TransferSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllTransferByLeadId(leadId: number): Observable<Object> {
    return this.http.get(`${this.url}/lead/${leadId}`);
  }
}
